export default __webpack_public_path__ + "static/media/Teixeira.57cd4d2a.jpg";